import { Box, SxProps, Typography, TypographyProps } from "@mui/material";
import { Fragment, ReactNode } from "react";
import { AutocompleteType } from "../../../types/autoComplete";

type Props = {
  list: (string | AutocompleteType | ReactNode)[];
  dotSx?: SxProps;
  TypographyProps?: TypographyProps;
};

const DotSeparatedStrings = ({ list, dotSx, TypographyProps = {} }: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        wordBreak: "normal",
      }}
    >
      {list.map((item, index) => {
        let content: ReactNode;

        // check if item is an object and has a 'name' property (i.e., if it's an AutocompleteType)
        if (typeof item === "object" && item !== null && "name" in item) {
          content = (item as AutocompleteType).name;
        } else if (typeof item === "string") {
          content = item; // if item is a string, use it as is
        } else {
          content = item; // if item is a ReactNode (component or JSX), return it as is
        }

        return (
          <Fragment key={index}>
            {typeof content === "string" ? (
              <Typography {...TypographyProps}>{content}</Typography>
            ) : (
              content
            )}
            {index !== list.length - 1 && (
              <Box
                sx={{
                  width: "5px",
                  height: "5px",
                  borderRadius: "100%",
                  backgroundColor: "#BFD4E4",
                  margin: "0 6px",
                  ...dotSx,
                }}
              />
            )}
          </Fragment>
        );
      })}
    </Box>
  );
};

export default DotSeparatedStrings;
